import { forwardRef } from 'react';
import { Link, type LinkProps } from 'react-router-dom';

import { useBureauShell } from './bureauShellContext';

const BUREAU_PATH = /^\/admin\/(travail|equipe)(?=$|[/?#])/u;

/**
 * A link to a page of the Bureau or the Équipe that keeps what the sidebar shows (principle 5): its
 * search, filters, unticked themes and lane survive the click. Any other link passes through. The
 * ref reaches the anchor (a menu item needs its node).
 */
export const KeptLink = forwardRef<HTMLAnchorElement, LinkProps>(function KeptLink({ to, ...props }, ref) {
  const { withKept } = useBureauShell();
  return <Link ref={ref} to={typeof to === 'string' && BUREAU_PATH.test(to) ? withKept(to) : to} {...props} />;
});
